exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".title{margin:0;padding:0;height:5rem;background:#fff}.title img,.title p{display:block;height:5rem}.title img{width:100%}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite/src/components/downloadHeader.vue"],"names":[],"mappings":"AACA,OACE,SAAU,AACV,UAAW,AACX,YAAa,AACb,eAAiB,CAClB,AAKD,oBAHE,cAAe,AACf,WAAa,CAMd,AAJD,WACE,UAAY,CAGb","file":"downloadHeader.vue","sourcesContent":["\n.title {\n  margin: 0;\n  padding: 0;\n  height: 5rem;\n  background: #fff;\n}\n.title p {\n  display: block;\n  height: 5rem;\n}\n.title img {\n  width: 100%;\n  height: 5rem;\n  display: block;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ed0d08be","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/downloadHeader.vue
// module id = 504
// module chunks = 1 2 3 4 5 6